/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_Hls_ManifestInputs */

const en_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS Manifest`)
};

const fr_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifeste HLS`)
};

const de_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS-Manifest`)
};

const it_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto HLS`)
};

const ru_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Манифест HLS`)
};

const es_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto HLS`)
};

const zh_cn2_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS清单`)
};

const ja_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLSマニフェスト`)
};

const hi_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एचएलएस मैनिफेस्ट`)
};

const pt_pt2_new_project_media_source_hls_manifest = /** @type {(inputs: New_Project_Media_Source_Hls_ManifestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto HLS`)
};

/**
* | output |
* | --- |
* | "HLS Manifest" |
*
* @param {New_Project_Media_Source_Hls_ManifestInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_hls_manifest = /** @type {((inputs?: New_Project_Media_Source_Hls_ManifestInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_Hls_ManifestInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_source_hls_manifest(inputs)
	if (locale === "de") return de_new_project_media_source_hls_manifest(inputs)
	if (locale === "it") return it_new_project_media_source_hls_manifest(inputs)
	if (locale === "ru") return ru_new_project_media_source_hls_manifest(inputs)
	if (locale === "es") return es_new_project_media_source_hls_manifest(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_source_hls_manifest(inputs)
	if (locale === "ja") return ja_new_project_media_source_hls_manifest(inputs)
	if (locale === "hi") return hi_new_project_media_source_hls_manifest(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_source_hls_manifest(inputs)
	return en_new_project_media_source_hls_manifest(inputs)
});